import { ModalContent } from "@kirvanobr/modal";
import { Button } from "@kirvanobr/button";
import { Typography } from "@kirvanobr/typography";
import { Info } from "../../Info/Info";

export function NotFinishedOnboard() {
  return (
    <ModalContent>
      {onClose => (
        <>
          <section>
            <div className="w-full text-center">
              <div className="w-full h-[120px] rounded-md bg-[url('/assets/banners/banner-marketplace-modal.png')] bg-cover" />
              <Typography variant="title" size="t4" weight="bold" className="mt-4">
                Marketplace de afiliados
              </Typography>
              <Typography variant="body" size="t4" weight="regular" className="mt-2">
                Não perca a chance de ter seus produtos em destaque e multiplicar suas vendas com a ajuda de afiliados
                parceiros.
              </Typography>
            </div>
          </section>

          <section>
            <Info>Conclua a configuração da sua conta para ter acesso a esse benefício.</Info>
          </section>

          <section>
            <Button color="primary" size="md" radius="full" fullWidth onClick={onClose}>
              Ok, entendi
            </Button>
          </section>
        </>
      )}
    </ModalContent>
  );
}
